import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select, Row, Col, Checkbox } from "antd";
import {
  getNielsenProductFilters,
  setNielsenProdFilters,
  setNielsenProdDataFilters,
  setnielsencolumnSelectionCheckbox,
  setincludeAllCheckboxNielsen,
} from "../../slicers/nielsenfilters.slicer";

const ProdFiltersSection = () => {
  const {
    prod_filters_nielsen,
    product_pet,
    product_portfolio,
    product_technology,
    product_manufacturer,
    product_brand,
    product_local_manufacturer,
    product_local_brand,
    product_sub_brand,
    product_pack_format,
    product_pack_size,
    product_number_in_pack,
    product_pack_type,
    product_ppg,
    product_flavour,
    product_size,
    product_description,
    product_long_description,
    product_ean_code,
    Growth_Drivers,
    nielsen_columnSelectionCheckbox,
  } = useSelector((state) => state.nielsenfilters);
  const dispatch = useDispatch();
  const includeAllLevels = [
    "customer_id__market",
    "customer_id__customer_desc",
    "customer_id__channel",
    "customer_id__retailer",
    "product_id__animal_type",
    "product_id__portfolio",
    "product_id__technology",
    "product_id__manufacturer",
    "product_id__brand",
    "product_id__local_manufacturer",
    "product_id__local_brand",
    "product_id__sub_brand",
    "product_id__pack_format",
    "product_id__pack_size",
    "product_id__number_in_pack",
    "product_id__pack_type",
    "product_id__ppg",
    "product_id__flavour",
    "product_id__product_size",
    "product_id__product_description",
    "product_id__product_long_description",
    "product_id__ean_code",
    "product_id__Growth_Drivers",
  ];
  //function for updating the product filters after selecting values from dropdowns
  const onSelection = (key, value) => {
    let newProdFilters = {
      ...prod_filters_nielsen,
      [key]: value,
    };
    dispatch(setNielsenProdFilters(newProdFilters));
    dispatch(setNielsenProdDataFilters(newProdFilters));
  };
  //function for handling dropdowns after clearing the selected options
  const handleOnClear = (key, value) => {
    let newFilters = {
      ...prod_filters_nielsen,
      [key]: value,
    };
    dispatch(setNielsenProdFilters(newFilters));
    dispatch(setNielsenProdDataFilters(newFilters));
    dispatch(getNielsenProductFilters(newFilters));
  };
  //function for maintaining selected columns in the nielsencolumnSelectionCheckbox array
  const columns_Selection = () => (e) => {
    if (e.target.checked) {
      let value = [...nielsen_columnSelectionCheckbox];
      value.push(e.target.value);
      dispatch(setnielsencolumnSelectionCheckbox(value)) &&
      nielsen_columnSelectionCheckbox.length === includeAllLevels.length - 1
        ? dispatch(setincludeAllCheckboxNielsen(["include_all_levels"]))
        : dispatch(setincludeAllCheckboxNielsen([""]));
    } else {
      let value = [...nielsen_columnSelectionCheckbox];
      value = value.filter((val) => val !== e.target.value);
      dispatch(setnielsencolumnSelectionCheckbox(value));
      dispatch(setincludeAllCheckboxNielsen([""]));
    }
  };
  return (
    <>
      <span className="solid-background"></span>
      <h5 style={{ marginTop: "-20px", marginLeft: "10px" }}>
        Product Details
      </h5>
      <Row gutter={10} style={{ marginTop: 10, marginBottom: 10 }}>
        <Col md={8} className="dropdown-card" style={{ marginTop: 10 }}>
          <Checkbox
            value={"product_id__animal_type"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes(
                "product_id__animal_type"
              )
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Pet</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_pet}
            onChange={(val) => onSelection("product_pet", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_pet", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_pet?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 10 }}>
          <Checkbox
            value={"product_id__portfolio"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("product_id__portfolio")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Portfolio</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_portfolio}
            onChange={(val) => onSelection("product_portfolio", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_portfolio", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_portfolio?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__technology"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("product_id__technology")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Technology</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_technology}
            onChange={(val) => onSelection("product_technology", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_technology", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_technology?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row gutter={10} style={{ marginTop: 10, marginBottom: 10 }}>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__manufacturer"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes(
                "product_id__manufacturer"
              )
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Global Manufacturer</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_manufacturer}
            onChange={(val) => onSelection("product_manufacturer", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_manufacturer", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_manufacturer?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__brand"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("product_id__brand")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Global Brand</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_brand}
            onChange={(val) => onSelection("product_brand", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_brand", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_brand?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__local_manufacturer"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes(
                "product_id__local_manufacturer"
              )
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Local Manufacturer</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_local_manufacturer}
            onChange={(val) => onSelection("product_local_manufacturer", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_local_manufacturer", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_local_manufacturer?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row gutter={10} style={{ marginTop: 10, marginBottom: 10 }}>
        <Col md={8} className="dropdown-card" style={{ marginTop: 10 }}>
          <Checkbox
            value={"product_id__local_brand"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes(
                "product_id__local_brand"
              )
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Local Brand</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_local_brand}
            onChange={(val) => onSelection("product_local_brand", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_local_brand", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_local_brand?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__sub_brand"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("product_id__sub_brand")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Sub Brand</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_sub_brand}
            onChange={(val) => onSelection("product_sub_brand", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_sub_brand", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_sub_brand?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__pack_format"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes(
                "product_id__pack_format"
              )
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Pack Format</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_pack_format}
            onChange={(val) => onSelection("product_pack_format", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_pack_format", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_pack_format?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row gutter={10} style={{ marginTop: 10, marginBottom: 10 }}>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__pack_size"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("product_id__pack_size")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Pack Size</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_pack_size}
            onChange={(val) => onSelection("product_pack_size", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_pack_size", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_pack_size?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__number_in_pack"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes(
                "product_id__number_in_pack"
              )
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Number in Pack</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_number_in_pack}
            onChange={(val) => onSelection("product_number_in_pack", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_number_in_pack", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_number_in_pack?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__pack_type"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("product_id__pack_type")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Pack Type</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_pack_type}
            onChange={(val) => onSelection("product_pack_type", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_pack_type", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_pack_type?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row gutter={10} style={{ marginTop: 10, marginBottom: 10 }}>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__ppg"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("product_id__ppg")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Promotable Group</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_ppg}
            onChange={(val) => onSelection("product_ppg", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_ppg", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_ppg?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__flavour"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("product_id__flavour")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Flavour</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_flavour}
            onChange={(val) => onSelection("product_flavour", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_flavour", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_flavour?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__product_size"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes(
                "product_id__product_size"
              )
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Product Size</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_size}
            onChange={(val) => onSelection("product_size", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_size", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_size?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row gutter={10} style={{ marginTop: 10, marginBottom: 10 }}>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__product_description"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes(
                "product_id__product_description"
              )
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Product Short Description</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_description}
            onChange={(val) => onSelection("product_description", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_description", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_description?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__product_long_description"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes(
                "product_id__product_long_description"
              )
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Product Long Description</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_long_description}
            onChange={(val) => onSelection("product_long_description", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_long_description", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_long_description?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__ean_code"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("product_id__ean_code")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">EAN Code</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.product_ean_code}
            onChange={(val) => onSelection("product_ean_code", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("product_ean_code", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {product_ean_code?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>

        <Col md={8} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"product_id__Growth_Drivers"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("product_id__Growth_Drivers")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Growth Drivers</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={prod_filters_nielsen.Growth_Drivers}
            onChange={(val) => onSelection("Growth_Drivers", val)}
            onBlur={() =>
              dispatch(getNielsenProductFilters(prod_filters_nielsen))
            }
            onClear={() => handleOnClear("Growth_Drivers", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {Growth_Drivers?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>


      </Row>
    </>
  );
};

export default ProdFiltersSection;
